import { Card, CardContent, Typography, Button, Box } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { useNavigate } from "react-router-dom";

interface ServiceLineUpCardProps {
  title: string;
  description: string;
  navigateTo?: string;
  navigationState?: any;
  hasServiceLineupAccess?: boolean;
}

const ServiceLineUpCard = ({
  title,
  description,
  navigateTo = "/",
  navigationState = {},
  hasServiceLineupAccess = false,
}: ServiceLineUpCardProps) => {
  const navigate = useNavigate();

  // If hasServiceLineupAccess is true, it means the privilege EXISTS, so button should be ENABLED
  // If hasServiceLineupAccess is false, it means the privilege does NOT exist, so button should be DISABLED
  const isDisabled = !hasServiceLineupAccess;

  const handleInfoClick = () => {
    if (!isDisabled) {
      navigate(navigateTo, { state: navigationState });
    }
  };

  return (
    <Card
      sx={{
        width: "100%",
        borderRadius: 4,
        boxShadow: 5,
        background: "linear-gradient(145deg, #1E4894 0%, #00B4EB 100%)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.03)",
        },
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="div" style={{ height: "60px" }}>
          {title}
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#d1e8ff",
              fontSize: "0.75rem",
              textAlign: "left",
              fontWeight: "bold",
            }}
          >
            {description}
          </Typography>
          <Button
            variant="contained"
            startIcon={<InfoIcon />}
            onClick={handleInfoClick}
            disabled={isDisabled}
            sx={{
              background: !isDisabled
                ? "linear-gradient(145deg,rgba(255, 255, 255, 0.48) 0%,rgba(208, 196, 24, 0.52) 100%)"
                : "rgba(0, 0, 0, 0.26)",
              color: "#fff",
              textTransform: "none",
              borderRadius: 2,
              minWidth: "auto",
              padding: "6px 12px",
              "&:hover": !isDisabled
                ? { backgroundColor: "#1f2937" }
                : {},
              cursor: !isDisabled ? "pointer" : "not-allowed",
            }}
          >
            Info
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ServiceLineUpCard;
